import * as React from 'react';
import Button from './Button';
var ImageModalContainerSVG = function (p) {
    var src = p.src, onRemoveModal = p.onRemoveModal, maxModalWidth = p.maxModalWidth, aspectRatio = p.aspectRatio;
    var keyHit = function (event) {
        if (event.code === 'Escape') {
            if (onRemoveModal)
                onRemoveModal();
        }
    };
    React.useEffect(function () {
        document.addEventListener("keydown", keyHit, false);
        // returned function will be called on component unmount 
        return function () {
            document.removeEventListener("keydown", keyHit, false);
        };
    }, []);
    //console.log('src', src.substring(34, 61));
    return (React.createElement("div", { className: "Modal SVG", style: {
            width: "100%",
            height: "100%",
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.8)",
            zIndex: 1000,
            backdropFilter: "blur(4px)"
        }, onClick: onRemoveModal },
        React.createElement("object", { data: src, type: "image/svg+xml", style: {
                width: maxModalWidth !== null && maxModalWidth !== void 0 ? maxModalWidth : "auto",
                maxWidth: "100%",
                maxHeight: "100%",
                height: "auto",
                aspectRatio: aspectRatio ? "".concat(aspectRatio) : undefined,
                transform: "translate(calc(-50% + 180px), -50%)",
                top: "50%",
                left: "50%",
                position: "absolute",
                backgroundColor: "#FFF",
                pointerEvents: "none"
            } }),
        React.createElement("div", { style: { position: "absolute", top: 5, right: 5 }, onClick: onRemoveModal },
            React.createElement(Button, { kind: "primary", icon: "times" }))));
};
export default ImageModalContainerSVG;
//# sourceMappingURL=ImageModalContainerSVG.js.map